export default __webpack_public_path__ + "static/58-71044e17010ebb3422c7306ce9a2d546.jpg";